export const samplePlans = [
    {
        id: "starter",
        name: "STARTER",
        duration: "1 MONTH ACCESS", // Renamed 'access' to 'duration' to match existing Plan interface
        price: 4999,
        originalPrice: null,
        description: "Foundational mastery for aspiring traders.",
        features: [
            "Institutional video modules",
            "Technical chart analysis",
            "Advanced price action",
            "Risk management protocol",
            "Community intelligence access",
            "Direct mentor guidance",
        ],
        buttonText: "SECURE ENROLLMENT",
        popular: false, // Renamed 'recommended' to 'popular' to match existing Plan interface
    },
    {
        id: "professional",
        name: "PROFESSIONAL",
        duration: "3 MONTHS ACCESS",
        price: 7999,
        originalPrice: 15000,
        description: "Strategic optimization for serious results.",
        features: [
            "Institutional video modules",
            "Technical chart analysis",
            "Advanced price action",
            "Risk management protocol",
            "Community intelligence access",
            "Direct mentor guidance",
        ],
        buttonText: "SECURE ENROLLMENT",
        popular: true,
    },
    {
        id: "premium",
        name: "PREMIUM",
        duration: "6 MONTHS ACCESS",
        price: 9999,
        originalPrice: 30000,
        description: "The complete sovereign trading architecture.",
        features: [
            "Institutional video modules",
            "Technical chart analysis",
            "Advanced price action",
            "Risk management protocol",
            "Community intelligence access",
            "Direct mentor guidance",
        ],
        buttonText: "SECURE ENROLLMENT",
        popular: false,
    },
];
